(function () {
  function initCoupons(scope = document) {

    // Create single iframe (global safe)
    let iframe = document.getElementById("discount-frame");

    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.id = "discount-frame";
      document.body.appendChild(iframe);
    }

    // =========================
    // APPLY COUPON
    // =========================
    scope.querySelectorAll("[data-apply-coupon]").forEach((button) => {

      // Prevent duplicate binding
      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";

      button.addEventListener("click", function () {

        const code = button.dataset.coupon;
        const couponItem = button.closest(".coupon-item");

        if (!couponItem) return;

        const message = couponItem.querySelector(".coupon-message");
        const loader = couponItem.querySelector(".coupon-loader");

        // UI state
        button.disabled = true;
        button.textContent = "Applying...";
        if (message) message.textContent = "";
        if (loader) loader.classList.add("active");

        // Reset previous handler (IMPORTANT)
        iframe.onload = null;

        iframe.onload = () => {

          const cartDrawer = document.querySelector("cart-drawer .drawer_inner");

          if (cartDrawer) {

            fetch(`${window.location.pathname}?section_id=cart-drawer`)
              .then((res) => {
                if (!res.ok) throw new Error("Cart fetch failed");
                return res.text();
              })
              .then((html) => {

                const doc = new DOMParser().parseFromString(html, "text/html");
                const newInner = doc.querySelector("cart-drawer .drawer_inner");

                if (!newInner) throw new Error("Drawer content missing");

                cartDrawer.innerHTML = newInner.innerHTML;

                if (message) {
                  message.textContent = `Discount "${code}" applied!`;
                  message.className = "coupon-message success";
                }

                // Re-init cart logic (your custom function)
                if (typeof reInitCartDrawer === "function") {
                  reInitCartDrawer();
                }

                // Re-init ALL scripts inside drawer
                document.dispatchEvent(new CustomEvent("theme:reinit", {
                  detail: { scope: cartDrawer }
                }));

                // Open drawer safely
                const drawer = document.querySelector("cart-drawer");
                if (drawer?.open) {
                  drawer.classList.remove("is-empty");
                  drawer.open();
                }

              })
              .catch((err) => {
                console.error("Discount error:", err);

                if (message) {
                  message.textContent = "Failed to apply discount.";
                  message.className = "coupon-message error";
                }
              })
              .finally(() => {
                if (loader) loader.classList.remove("active");
                button.disabled = false;
                button.textContent = "Apply";
              });

          } else {
            window.location.href = "/cart";
          }
        };

        // Trigger discount
        iframe.src = `/discount/${encodeURIComponent(code)}?redirect=/cart`;

      });

    });

    // =========================
    // COPY CODE
    // =========================
    scope.querySelectorAll("[data-copy-coupon]").forEach((button) => {

      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";

      button.addEventListener("click", () => {

        const text = button.dataset.copy;

        navigator.clipboard.writeText(text).then(() => {
          button.textContent = "Copied!";
          button.classList.add("copied");

          setTimeout(() => {
            button.textContent = "Copy Code";
            button.classList.remove("copied");
          }, 2000);
        }).catch(err => {
          console.error("Copy failed:", err);
        });

      });

    });

  }

  // =========================
  // INITIAL LOAD
  // =========================
  document.addEventListener("DOMContentLoaded", () => {
    initCoupons(document);
  });

  // =========================
  // SHOPIFY EVENTS
  // =========================
  document.addEventListener("shopify:section:load", (e) => {
    initCoupons(e.target);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    // Optional cleanup if needed later
  });

  // =========================
  // CUSTOM RE-INIT
  // =========================
  document.addEventListener("theme:reinit", (e) => {
    initCoupons(e.detail?.scope || document);
  });

})();